import { NgIf } from '@angular/common';
import { Component, Input, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
    selector: 'fuse-fullscreen',
    templateUrl: './fullscreen.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [
        NgIf,
        MatButtonModule,
        MatIconModule,
        MatTooltipModule
    ],
    styles: [
        `
            :host ::ng-deep {
                .mat-mdc-icon-button {
                    --mdc-icon-button-icon-color: #E9EDEF;
                }
                
                .mat-icon {
                    color: #E9EDEF !important;
                }
            }
        `
    ]
})
export class FuseFullscreenComponent {
    @Input() tooltip: string;
    isFullscreen: boolean = false;

    /**
     * Toggle the fullscreen mode
     */
    toggleFullscreen(): void {
        // Check if the fullscreen is open
        this.isFullscreen = document.fullscreenElement !== null;

        // Toggle the fullscreen
        if (this.isFullscreen) {
            document.exitFullscreen();
        } else {
            document.documentElement.requestFullscreen();
        }
    }
}
